export enum OverlaidAnimationStyle {
  HEARTS = "HEARTS",
  CHECKMARK = "CHECKMARK",
  HEART = "HEART",
  THANKYOU = "THANKYOU",
}
